import { Select } from 'antd';

import AlertIcon from '../../../assets/icons/AlertIcon';

const { Option } = Select;

const Alert = ({ options, alert, onChange }) => {
  const handleChange = (value) => {
    const selectedValue = value;
    const selectedOption = options.find((option) => option.value === selectedValue);
    if (selectedOption) {
      onChange(selectedOption);
    }
  };

  return (
    <>
      <label className="w-[274px]">
        <span className="pl-1">Alerts</span>
        <Select defaultValue={options[0]} value={alert} onChange={handleChange} className="w-full">
          {options.map((filter) => (
            <Option key={filter.value} value={filter.value}>
              <div className="flex items-center gap-2">
                <AlertIcon /> {filter.label}
              </div>
            </Option>
          ))}
        </Select>
      </label>
    </>
  );
};
export default Alert;
